import { type PropsWithChildren, type ReactNode, useState } from 'react'

import { Collapsible, IconChevronDown, IconChevronUp } from '@procurify/ui'

import { ConversationOrderSummarySectionHeaderStyled } from './styles/ConversationOrderSummarySectionHeaderStyled'
import { ConversationOrderSummarySectionStyled } from './styles/ConversationOrderSummarySectionStyled'

export interface IConversationOrderSummarySectionProps {
  title: ReactNode
  ariaLabel: string
  isCollapsible?: boolean
}

export const ConversationOrderSummarySection = ({
  title,
  ariaLabel,
  isCollapsible = true,
  children,
}: PropsWithChildren<IConversationOrderSummarySectionProps>) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleChange = (wasOpen: boolean) => {
    setIsOpen(!wasOpen)
  }

  const header = (
    <ConversationOrderSummarySectionHeaderStyled>
      {title}
    </ConversationOrderSummarySectionHeaderStyled>
  )

  if (!isCollapsible)
    return (
      <ConversationOrderSummarySectionStyled aria-label={ariaLabel}>
        {header}
        {children}
      </ConversationOrderSummarySectionStyled>
    )

  return (
    <ConversationOrderSummarySectionStyled aria-label={ariaLabel}>
      <Collapsible
        title={header}
        iconPosition='right'
        expandIcon={<IconChevronDown />}
        collapseIcon={<IconChevronUp />}
        open={isOpen}
        onChange={handleChange}
      >
        {children}
      </Collapsible>
    </ConversationOrderSummarySectionStyled>
  )
}
